import React, { useState, useEffect } from 'react'

import {
	Button,
	CircularProgress,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	TextField,
	MenuItem,
	Switch,
	Icon
} from '@material-ui/core'

import { isEmpty } from 'lodash'

import { useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import { updatePetVisitAssignments } from '../../../actions/visits/visits.actions'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start',
		padding: '0px 24px'
	},
	checkbox: {
		'&.Mui-disabled.Mui-checked .MuiIconButton-label .MuiSvgIcon-root': {
			fill: '#A2A1A4'
		}
	},
	avatar: {
		background: '#C4C4C4',
		height: '32px',
		width: '32px',
		marginTop: '12px',
		marginBottom: '12px'
	},
	textField: {
		marginBottom: '8px',
		'& .MuiTextField-root': {
			minWidth: '100%',
			marginBottom: '16px'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '100%'
		}
	},
	sharingWrapper: {
		height: 56,
		width: '100%',
		padding: '0px 12px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderRadius: 6,
		background: '#F9F9F9'
	},
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&$checked': {
			transform: 'translateX(20px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#6B4AD6',
				opacity: 1
			},
			'& .far::before': {
				color: '#6B4AD6'
			}
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6'
			//border: "6px solid #fff",
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: '#F3F3F3',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px',
			lineHeight: '15px'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	},
	checked: {}
}))

const EditAssignmentsDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [groomingServiceType, setGroomingServiceType] = useState('')
	const [loading, setLoading] = useState(false)
	const setInitialState = () => {
		setGroomingServiceType('')
		setLoading(false)
	}

	const isDisabled = () => {
		if (!groomingServiceType) return true
		return false
	}

	let { isShown, setIsShown, pet, facility, visit, updateServiceType } = props

	useEffect(() => {
		if (visit && visit.grooming_service_type) setGroomingServiceType(visit.grooming_service_type)
	}, [visit])

	const groomingServices = facility?.services?.grooming?.services || []

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => {
				setInitialState()
				setIsShown(false)
			}}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px',
					padding: '24px 0px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 18,
					padding: '0px 24px'
				}}>
				EDIT GROOMING SERVICE
			</DialogTitle>
			<DialogContent
				style={{
					padding: '0px 24px'
				}}>
				<div className={classes.textField}>
					<TextField
						select
						label="Sub-Service Type"
						variant="filled"
						disabled={visit && visit.status.id === 5}
						value={groomingServiceType}
						style={{ textTransform: 'capitalize' }}
						onChange={(e) => setGroomingServiceType(e.target.value)}>
						{groomingServices.map((s) => {
							return (
								<MenuItem value={s.type} style={{ textTransform: 'capitalize' }}>
									{s.name}
								</MenuItem>
							)
						})}
					</TextField>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					disabled={isDisabled() || loading}
					variant="contained"
					onClick={() => {
						setLoading(true)
						updateServiceType(groomingServiceType)
						setTimeout(() => {
							setLoading(false)
							setIsShown(false)
						}, 1000)
					}}
					color="secondary">
					{loading ? <CircularProgress /> : 'Save'}
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						setInitialState()
						setIsShown(false)
					}}
					color="secondary">
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditAssignmentsDialog
